import React, { Component } from "react";

class SVG extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    let { name, className, onClick } = this.props;

    function RenderSVG() {
      // eslint-disable-next-line default-case
      switch (name) {
        case "search":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
            </svg>
          );
        case "arrow-down":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M 2.65625 6.25 L 1.34375 7.75 L 11.34375 16.75 L 12 17.34375 L 12.65625 16.75 L 22.65625 7.75 L 21.34375 6.25 L 12 14.65625 Z"
                id="surface1"
              />
            </svg>
          );
        case "play":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <path
                d="M 20.207031 11.855469 L 6.902344 5.261719 C 6.5 5.058594 6.019531 5.078125 5.632813 5.3125 C 5.246094 5.542969 5.015625 5.957031 5.015625 6.402344 L 5.015625 19.601563 C 5.015625 20.042969 5.246094 20.457031 5.632813 20.6875 C 5.84375 20.816406 6.078125 20.878906 6.316406 20.878906 C 6.519531 20.878906 6.71875 20.832031 6.902344 20.742188 L 20.210938 14.140625 C 20.648438 13.925781 20.925781 13.484375 20.925781 13 C 20.925781 12.515625 20.644531 12.074219 20.207031 11.855469 Z"
                id="surface1"
              />
            </svg>
          );
        case "close":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 192 192"
            >
              <g
                fill="none"
                strokeMiterlimit="10"
                fontFamily="none"
                fontWeight="none"
                fontSize="none"
                textAnchor="none"
              >
                <path d="M0,192v-192h192v192z" />
                <path
                  d="M51.0625,38.275c-5.20634,0.00645 -9.89015,3.1654 -11.8469,7.99004c-1.95675,4.82464 -0.7966,10.35375 2.9344,13.98496l35.75,35.75l-35.75,35.75c-3.34383,3.21046 -4.6908,7.97781 -3.52143,12.46344c1.16937,4.48563 4.67237,7.98862 9.15799,9.15799c4.48563,1.16937 9.25297,-0.1776 12.46343,-3.52143l35.75,-35.75l35.75,35.75c3.21045,3.34388 7.97782,4.69089 12.46348,3.52152c4.48566,-1.16937 7.98867,-4.67238 9.15804,-9.15804c1.16937,-4.48566 -0.17764,-9.25302 -3.52152,-12.46348l-35.75,-35.75l35.75,-35.75c3.78573,-3.67989 4.92402,-9.30644 2.86636,-14.16848c-2.05765,-4.86204 -6.88913,-7.96214 -12.16636,-7.80652c-3.32542,0.09909 -6.48164,1.4889 -8.8,3.875l-35.75,35.75l-35.75,-35.75c-2.41289,-2.48033 -5.72714,-3.87818 -9.1875,-3.875z"
                  fill="#fff"
                />
              </g>
            </svg>
          );
        case "external":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M 19.980469 2.9902344 A 1.0001 1.0001 0 0 0 19.869141 3 L 15 3 A 1.0001 1.0001 0 1 0 15 5 L 17.585938 5 L 8.2929688 14.292969 A 1.0001 1.0001 0 1 0 9.7070312 15.707031 L 19 6.4140625 L 19 9 A 1.0001 1.0001 0 1 0 21 9 L 21 4.1269531 A 1.0001 1.0001 0 0 0 19.980469 2.9902344 z M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 13 A 1.0001 1.0001 0 1 0 19 13 L 19 19 L 5 19 L 5 5 L 11 5 A 1.0001 1.0001 0 1 0 11 3 L 5 3 z" />
            </svg>
          );
        case "indicator":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <path
                d="M 22.726563 18 C 23.179688 18 23.789063 17.699219 23.941406 17.25 C 24.09375 16.800781 23.941406 16.351563 23.636719 15.898438 C 20.292969 11.101563 13.910156 6.300781 13.910156 6.300781 C 13.910156 6.300781 13.609375 6 13.003906 6 C 12.390625 6 12.089844 6.300781 12.089844 6.300781 C 12.089844 6.300781 5.707031 11.101563 2.363281 15.898438 C 2.058594 16.351563 1.90625 16.800781 2.058594 17.25 C 2.210938 17.699219 2.820313 18 3.273438 18 Z"
                id="surface1"
              />
            </svg>
          );
        case "long-arrow":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M 12 1 L 8 5 L 11 5 L 11 23 L 13 23 L 13 5 L 16 5 L 12 1 z" />
            </svg>
          );
        case "info":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 16 16"
            >
              <path
                d="M 7.5 1 C 3.917969 1 1 3.917969 1 7.5 C 1 11.082031 3.917969 14 7.5 14 C 11.082031 14 14 11.082031 14 7.5 C 14 3.917969 11.082031 1 7.5 1 Z M 7.5 2 C 10.542969 2 13 4.457031 13 7.5 C 13 10.542969 10.542969 13 7.5 13 C 4.457031 13 2 10.542969 2 7.5 C 2 4.457031 4.457031 2 7.5 2 Z M 7 4 L 7 5 L 8 5 L 8 4 Z M 7 6 L 7 11 L 8 11 L 8 6 Z"
                id="surface1"
              />
            </svg>
          );
        case "remove":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 16 16"
            >
              <path
                d="M 6.496094 1 C 5.675781 1 5 1.675781 5 2.496094 L 5 3 L 2 3 L 2 4 L 3 4 L 3 12.5 C 3 13.328125 3.671875 14 4.5 14 L 10.5 14 C 11.328125 14 12 13.328125 12 12.5 L 12 4 L 13 4 L 13 3 L 10 3 L 10 2.496094 C 10 1.675781 9.324219 1 8.503906 1 Z M 6.496094 2 L 8.503906 2 C 8.785156 2 9 2.214844 9 2.496094 L 9 3 L 6 3 L 6 2.496094 C 6 2.214844 6.214844 2 6.496094 2 Z M 5 5 L 6 5 L 6 12 L 5 12 Z M 7 5 L 8 5 L 8 12 L 7 12 Z M 9 5 L 10 5 L 10 12 L 9 12 Z"
                id="surface1"
              />
            </svg>
          );
        case "settings":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <path
                d="M 6.570313 1 L 6.328125 2.289063 C 5.398438 2.5625 4.570313 3.046875 3.890625 3.695313 L 2.652344 3.261719 L 1.222656 5.738281 L 2.210938 6.585938 C 2.097656 7.042969 2 7.507813 2 8 C 2 8.492188 2.097656 8.957031 2.210938 9.414063 L 1.222656 10.261719 L 2.652344 12.738281 L 3.886719 12.300781 C 4.570313 12.957031 5.398438 13.4375 6.328125 13.714844 L 6.570313 15 L 9.429688 15 L 9.671875 13.714844 C 10.601563 13.4375 11.429688 12.953125 12.109375 12.300781 L 13.34375 12.738281 L 14.777344 10.261719 L 13.785156 9.414063 C 13.898438 8.957031 14 8.492188 14 8 C 14 7.507813 13.902344 7.042969 13.789063 6.585938 L 14.777344 5.738281 L 13.347656 3.261719 L 12.113281 3.695313 C 11.429688 3.042969 10.601563 2.5625 9.671875 2.289063 L 9.429688 1 Z M 7.398438 2 L 8.601563 2 L 8.796875 3.054688 L 9.117188 3.132813 C 10.109375 3.359375 10.984375 3.878906 11.65625 4.597656 L 11.878906 4.835938 L 12.894531 4.480469 L 13.496094 5.519531 L 12.683594 6.21875 L 12.78125 6.53125 C 12.921875 6.992188 13 7.488281 13 8 C 13 8.511719 12.921875 9.003906 12.78125 9.46875 L 12.683594 9.78125 L 13.496094 10.480469 L 12.894531 11.519531 L 11.878906 11.160156 L 11.65625 11.402344 C 10.984375 12.121094 10.109375 12.640625 9.117188 12.871094 L 8.796875 12.941406 L 8.601563 14 L 7.398438 14 L 7.203125 12.941406 L 6.882813 12.871094 C 5.890625 12.640625 5.015625 12.121094 4.34375 11.402344 L 4.117188 11.160156 L 3.101563 11.519531 L 2.503906 10.480469 L 3.316406 9.78125 L 3.21875 9.46875 C 3.078125 9.007813 3 8.511719 3 8 C 3 7.488281 3.078125 6.992188 3.21875 6.53125 L 3.316406 6.21875 L 2.503906 5.519531 L 3.101563 4.480469 L 4.121094 4.835938 L 4.34375 4.597656 C 5.015625 3.878906 5.890625 3.359375 6.882813 3.132813 L 7.203125 3.054688 Z M 8 5 C 6.347656 5 5 6.347656 5 8 C 5 9.652344 6.347656 11 8 11 C 9.652344 11 11 9.652344 11 8 C 11 6.347656 9.652344 5 8 5 Z M 8 6 C 9.109375 6 10 6.890625 10 8 C 10 9.109375 9.109375 10 8 10 C 6.890625 10 6 9.109375 6 8 C 6 6.890625 6.890625 6 8 6 Z"
                id="surface1"
              />
            </svg>
          );
        case "personalize":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="100"
              height="100"
              viewBox="0 0 16 16"
            >
              <path
                d="M 7.5 1 C 6.675781 1 6 1.675781 6 2.5 C 6 3.324219 6.675781 4 7.5 4 C 8.324219 4 9 3.324219 9 2.5 C 9 1.675781 8.324219 1 7.5 1 Z M 7.5 4 L 6.5 4 C 5.675781 4 5 4.675781 5 5.5 L 5 8.707031 L 6 9.707031 L 6 12 L 9 12 L 9 9.707031 L 10 8.707031 L 10 5.5 C 10 4.675781 9.324219 4 8.5 4 Z M 7.5 2 C 7.78125 2 8 2.21875 8 2.5 C 8 2.78125 7.78125 3 7.5 3 C 7.21875 3 7 2.78125 7 2.5 C 7 2.21875 7.21875 2 7.5 2 Z M 6.5 5 L 8.5 5 C 8.78125 5 9 5.21875 9 5.5 L 9 8.292969 L 8 9.292969 L 8 11 L 7 11 L 7 9.292969 L 6 8.292969 L 6 5.5 C 6 5.21875 6.21875 5 6.5 5 Z M 4.222656 9.34375 C 2.371094 9.71875 1 10.433594 1 11.5 C 1 13.140625 4.269531 14 7.5 14 C 10.730469 14 14 13.140625 14 11.5 C 14 10.433594 12.628906 9.71875 10.777344 9.34375 L 10 10.121094 L 10 10.1875 C 11.949219 10.5 13 11.128906 13 11.5 C 13 12.007813 11.058594 13 7.5 13 C 3.941406 13 2 12.007813 2 11.5 C 2 11.128906 3.050781 10.5 5 10.1875 L 5 10.121094 Z"
                id="surface1"
              />
            </svg>
          );
        case "email":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <path
                d="M 1.5 1 C 0.675781 1 0 1.675781 0 2.5 L 0 10.5 C 0 11.324219 0.675781 12 1.5 12 L 2 12 L 2 12.5 C 2 13.324219 2.675781 14 3.5 14 L 8 14 L 8 13 L 3.5 13 C 3.21875 13 3 12.78125 3 12.5 L 3 4.980469 L 8.5 9.125 L 14 4.980469 L 14 10 L 15 10 L 15 4.5 C 15 3.675781 14.324219 3 13.5 3 L 13 3 L 13 2.5 C 13 1.675781 12.324219 1 11.5 1 Z M 1.5 2 L 11.5 2 C 11.78125 2 12 2.21875 12 2.5 L 12 3 L 3.5 3 C 2.675781 3 2 3.675781 2 4.5 L 2 11 L 1.5 11 C 1.21875 11 1 10.78125 1 10.5 L 1 2.5 C 1 2.21875 1.21875 2 1.5 2 Z M 3.5 4 L 13.5 4 C 13.539063 4 13.574219 4.011719 13.609375 4.023438 L 8.5 7.875 L 3.390625 4.023438 C 3.425781 4.011719 3.460938 4 3.5 4 Z M 13 11 L 13 13 L 9 13 L 9 14 L 13 14 L 13 16 L 15.5 13.5 Z"
                id="surface1"
              />
            </svg>
          );
        case "help":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <path
                d="M 7.5 1 C 3.917969 1 1 3.917969 1 7.5 C 1 11.082031 3.917969 14 7.5 14 C 11.082031 14 14 11.082031 14 7.5 C 14 3.917969 11.082031 1 7.5 1 Z M 7.5 2 C 10.542969 2 13 4.457031 13 7.5 C 13 10.542969 10.542969 13 7.5 13 C 4.457031 13 2 10.542969 2 7.5 C 2 4.457031 4.457031 2 7.5 2 Z M 7.558594 4 C 6.347656 4.070313 5.359375 5.085938 5.359375 6.320313 L 6.359375 6.320313 C 6.359375 5.507813 7.0625 4.871094 7.921875 5.019531 C 8.535156 5.125 9.019531 5.726563 9 6.359375 C 8.984375 6.914063 8.660156 7.265625 8.183594 7.476563 C 7.886719 7.609375 7.605469 7.734375 7.367188 7.984375 C 7.128906 8.234375 7 8.605469 7 9 L 8 9 C 8 8.773438 8.03125 8.738281 8.09375 8.671875 C 8.152344 8.609375 8.316406 8.511719 8.585938 8.390625 C 9.332031 8.066406 9.972656 7.351563 10 6.390625 C 10.035156 5.253906 9.21875 4.226563 8.089844 4.03125 C 7.910156 4.003906 7.730469 3.992188 7.558594 4 Z M 7 10 L 7 11 L 8 11 L 8 10 Z"
                id="surface1"
              />
            </svg>
          );
        case "plus":
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0"
              y="0"
              viewBox="0 0 16 16"
            >
              <path d="M7 1v6H1v1h6v6h1V8h6V7H8V1z" />
            </svg>
          );
        case "check":
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0"
              y="0"
              viewBox="0 0 16 16"
            >
              <path d="M14.5 2.793l-9 9-3.648-3.645-.352-.355-.707.707.355.352L5.5 13.207 15.207 3.5z" />
            </svg>
          );
        case "mobile-home":
          return (
            <svg width="24" height="24">
              <rect width="24" height="24" fill="none" rx="0" ry="0" />
              <path
                fillRule="evenodd"
                d="M12.438 3.589a.6.6 0 00-.877 0l-7 7.5a.6.6 0 00-.161.41v8.5a.6.6 0 00.6.6h14a.6.6 0 00.6-.6v-8.5a.6.6 0 00-.162-.41L18.1 9.655V4.998a.6.6 0 00-.6-.6H15a.6.6 0 00-.6.6v.693l-1.962-2.102zM15.6 6.976l1.3 1.393V5.6h-1.3v1.377zm-10 12.422v-7.663L12 4.878l6.4 6.857v7.663H5.6z"
                clipRule="evenodd"
              />
            </svg>
          );
        case "mobile-player":
          return (
            <svg width="24" height="24">
              <rect width="24" height="24" fill="none" rx="0" ry="0" />
              <path
                fillRule="evenodd"
                d="M7.54 3.99A1 1 0 006 4.832v14.336a1 1 0 001.54.841l11.152-7.168a1 1 0 000-1.682L7.54 3.99zm.43 1.704a.5.5 0 00-.77.42v11.771a.5.5 0 00.77.421l9.174-5.885a.5.5 0 000-.842L7.97 5.694z"
                clipRule="evenodd"
              />
            </svg>
          );
        case "mobile-calendar":
          return (
            <svg width="24" height="24">
              <rect width="24" height="24" fill="none" rx="0" ry="0" />
              <path
                fillRule="evenodd"
                d="M20 9H8M8.6 3a.6.6 0 00-1.2 0v1.4H6A2.6 2.6 0 003.4 7v11A2.6 2.6 0 006 20.6h12a2.6 2.6 0 002.6-2.6V7A2.6 2.6 0 0018 4.4h-1.4V3a.6.6 0 10-1.2 0v1.4H8.6V3zM8 5.6h10A1.4 1.4 0 0119.4 7v11a1.4 1.4 0 01-1.4 1.4H6A1.4 1.4 0 014.6 18V7A1.4 1.4 0 016 5.6h2zm10 10.9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
                clipRule="evenodd"
              />
            </svg>
          );
        case "mobile-menu":
          return (
            <svg width="24" height="24">
              <rect width="24" height="24" fill="none" rx="0" ry="0"></rect>
              <path
                fillRule="evenodd"
                d="M8.4 9a3.6 3.6 0 117.2 0 3.6 3.6 0 01-7.2 0zM12 6.6a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8z"
                clipRule="evenodd"
              ></path>
              <path
                fillRule="evenodd"
                d="M12 2.4a9.6 9.6 0 00-6.6 16.572V19h.03A9.567 9.567 0 0012 21.6a9.567 9.567 0 006.57-2.6h.03v-.029A9.6 9.6 0 0012 2.4zm6.385 15.058a8.4 8.4 0 10-12.77 0A5.602 5.602 0 0111 13.4h2a5.602 5.602 0 015.385 4.058zM6.633 18.462A8.366 8.366 0 0012 20.4a8.366 8.366 0 005.367-1.938A4.4 4.4 0 0013 14.6h-2a4.4 4.4 0 00-4.367 3.862z"
                clipRule="evenodd"
              ></path>
            </svg>
          );
        case "mobile-search":
          return (
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
            </svg>
          );
        case "mobile-close":
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              x="0"
              y="0"
              viewBox="0 0 24 24"
            >
              <path d="M5.99 4.99a1 1 0 00-.697 1.717L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293a1 1 0 101.414-1.414L13.414 12l5.293-5.293a1 1 0 00-.727-1.717 1 1 0 00-.687.303L12 10.586 6.707 5.293a1 1 0 00-.717-.303z"></path>
            </svg>
          );
        case "back":
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0"
              y="0"
              viewBox="0 0 50 50"
            >
              <path d="M25 2C12.316 2 2 12.316 2 25s10.316 23 23 23 23-10.316 23-23S37.684 2 25 2zm12 24H15.414l6.293 6.293a1 1 0 11-1.414 1.414l-8-8a1 1 0 01-.215-1.09 1 1 0 01.215-.324l8-8a1 1 0 111.414 1.414L15.414 24H37a1 1 0 110 2z" />
            </svg>
          );
      }
    }
    return (
      <div
        style={{ display: "inline-flex" }}
        className={className}
        onClick={onClick}
      >
        {RenderSVG()}
      </div>
    );
  }
}

export default SVG;
